import { c as m } from "./cacheFetch-B9lN1k3g.js";
import { m as u } from "./morphNodes-DP-Jfkiq.js";
const S = () => ({
  productSoldOut: !1,
  hasRequired: !0,
  controller: new AbortController(),
  checkRequired(t) {
    const e = new FormData(t);
    this.hasRequired = t.elements.toArray().filter(
      (r) => r instanceof HTMLInputElement || r instanceof HTMLSelectElement || r instanceof HTMLTextAreaElement
    ).filter((r) => r.required && r.name?.endsWith("[id]")).map((r) => e.get(r.name)).every((r) => r && r !== "null");
  },
  init() {
    const t = this.$el.querySelector("form[action='/cart/add']");
    t?.addEventListener(
      "change",
      () => {
        this.checkRequired(t);
      },
      {
        signal: this.controller.signal
      }
    ), t && this.checkRequired(t);
  },
  destroy() {
    this.controller.abort();
  },
  async changeVariant(t) {
    console.log("Replacing page with:", t);
    const e = new URL(t, window.location.origin);
    window.history.replaceState({}, "", e);
    const r = await m(e);
    if (!r) {
      console.error("Failed to fetch the new variant page:", t);
      return;
    }
    const o = this.$el.closest('section[id^="shopify-section"]');
    if (!o) {
      console.warn("No current section found for variant change");
      return;
    }
    u(r, `#${o.id}`);
  },
  async handleSubmit(t) {
    if (!t.reportValidity()) return;
    const e = new FormData(t);
    if (Array.from(e.entries()).filter(c(f)).filter(([n, s]) => s === "").forEach(([n]) => e.delete(n)), e.has("items[0][properties][_bundle_parent]")) {
      const n = Array.from(e.entries()).filter(c("[id]")).map(([i, a]) => a).map(String), s = await A(
        n.filter((i) => i !== "" && i !== "null")
      ), h = parseInt(e.get("items[0][quantity]")) || 1;
      n.forEach((i, a) => {
        i === "" || i === "null" ? Array.from(e.keys()).filter(d(`items[${a}]`)).forEach(e.delete.bind(e)) : (e.append(`items[${a}][properties][_bundle_id]`, s), e.has(`items[${a}][quantity]`) || e.append(`items[${a}][quantity]`, h.toString()));
      });
    }
    const r = Array.from(t.elements).find(
      (n) => n.id.startsWith("product-notes-")
    );
    Array.from(e.entries()).filter(c("[quantity]")).filter(([n, s]) => s === "0").map(l("[quantity]")).forEach(
      (n) => Array.from(e.keys()).filter(d(n)).forEach(e.delete.bind(e))
    ), r?.value && Array.from(e.entries()).filter(c("[id]")).map(l("[id]")).map(
      y(
        r.name.match(/\[properties\]\[.+\]/)?.[0]
      )
    ).forEach((n) => {
      e.append(n, r.value);
    });
    const o = await fetch(t.action + ".js", {
      method: t.method,
      body: e
    });
    if (!o.ok) {
      console.error("Failed to submit form:", o.statusText);
      return;
    }
    this.$store.cart.open();
  }
}), b = () => ({
  controller: new AbortController(),
  hasQuantity: !1,
  init() {
    const t = this.$el.form;
    console.assert(t, "LockedATC must be initialized on a button in a form"), t?.addEventListener(
      "change",
      () => {
        this.checkQuantity(t);
      },
      {
        signal: this.controller.signal
      }
    ), t && this.checkQuantity(t);
  },
  checkQuantity(t) {
    const e = new FormData(t);
    this.hasQuantity = Array.from(e.entries()).filter(c("[quantity]")).map(p).map(Number).some((r) => r > 0);
  },
  destroy() {
    this.controller.abort();
  }
}), f = ["[Send on]", "[Message]"], c = (t) => ([e]) => Array.isArray(t) ? t.some((r) => e.endsWith(r)) : e.endsWith(t), p = ([t, e]) => e, l = (t) => ([e]) => Array.isArray(t) ? t.reduce(
  (r, o) => r.endsWith(o) ? r.slice(0, -o.length) : r,
  e
) : e.endsWith(t) ? e.slice(0, -t.length) : e, y = (t = "") => (e) => e + t, d = (t) => (e) => e.startsWith(t), A = async (t) => {
  const e = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(t.toSorted().join("-"))
  );
  return Array.from(new Uint8Array(e)).map((r) => r.toString(16).padStart(2, "0")).join("");
};
Array.prototype.toSorted ??= function(t) {
  return [...this].sort(t);
};
HTMLFormControlsCollection.prototype.toArray ??= function() {
  return Array.from(this);
};
export {
  b as LockedATC,
  S as ProductMain,
  S as default
};
